import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted,onActivated, reactive,defineAsyncComponent, watch, toRef} from "vue";
// import router from "@/router";
import Swiper from "@/components/home/Swiper.vue";
import Populartoday from "@/components/home/Populartoday.vue";

// import Loading from "@/components/Loading.vue";
import Platform from "@/config/platform";
import { storeToRefs } from "pinia";
import { serverConfigPiniaState } from "@/store/serverConfig";
import router from "@/router";
import IMUtils from "@/network/socket/imUtils";
import { encryptionGetActiveAdInfo } from "@/api/php/me";
import { Storage } from "@/uitls/Storage";
import {
  nativeToNewWeb,
  cheackQuery,
  goHome,
  ToBack,
  nativeToLogin,
  toLocationBrowser,
  toMsgChat,
  toMsgList,
  toRemotePlay,
  toDownloadApp,
  checkSetNickname,
} from "@/uitls/native";
import EventBus from "@/uitls/EventBus";


const __default__ = {
  name: "HomeIndex",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  homeTabs: Array
},
  emits: ["hometab"],
  setup(__props, { expose, emit }) {
  expose();

const props = __props

const TopNav = defineAsyncComponent(() =>
  import("@/components/home/HomeNav.vue")
);

const ConfigpiniaStore = serverConfigPiniaState();
const { is_has_history } = storeToRefs(ConfigpiniaStore);



// const pos2 = require(`@/assets/${process.env.VUE_APP_NAME}/home_post_2.png`)
// const pos1 = require(`@/assets/${process.env.VUE_APP_NAME}/home_post_1.png`)

const downLogo = require(`@/assets/${process.env.VUE_APP_NAME}/logo.png`);
const close_icon = require(`@/assets/images/guanbi_icon.png`)
const kehu_icon = require(`@/assets/${process.env.VUE_APP_NAME}/ic_kehu.png`);
const play_off_btn = require(`@/assets/images/play_off_btn.png`)
// const showFuli = ref(true); // 是否显示右下角福利按钮
// const showInvite = ref(true); // 是否显示右下角邀请按钮
const showKehu = ref(true);
const standalone = Platform.standalone;
const activeColor = process.env.VUE_APP_DOWNLOAD_COLOR as string;
const activeFontColor = process.env.VUE_APP_DOWNLOAD_FONT_COLOR as string;

const showDownApp = ref(!standalone && Platform.client == "h5");
const showActiveAlertView = ref(false);
const activeCloseIcon = require("@/assets/images/active_close.png");
const active_bg = require("@/assets/images/active_ad_bg.png");
const activeObj = ref({});
// localStorage key
const LAST_TIME_KEY = 'lastPopupTime';         // 上次弹窗时间
const LAST_REQ_KEY  = 'lastRequestTime';       // 上次请求时间
const THROTTLE_MS   = 60 * 60 * 1000; 
const jumpTopBottom = ref('120px')
const showTodayMatch = ref(false);

const homeCategoryType_vi = ref();

// const homeTabs = toRef(props, "homeTabs");

const defaultActive = ref(0);

const onNavTab = (index)=>{
  if(props.homeTabs.length == 0){
    return;
  }
  defaultActive.value = index;
  const obj = props.homeTabs[index];
  if(index == 0){ //斗鸡
    showTodayMatch.value = false;
  }else{
    showTodayMatch.value = true;
  }
  
  homeCategoryType_vi.value = obj.type;
   console.log("拿到了obj.type = ", obj.type);
  // EventBus.emit('changeViCategory', obj.type);
}

watch(() =>props.homeTabs.length, 
  (newVal, oldVal) =>{
    console.log('触发了一次hometabs');
    
    if(newVal&& newVal>0){
      //第一次进入默认加载斗鸡页面数据
      onNavTab(0);
    }
  },
  {immediate:true, flush: 'post'}  // 初始不调用回调，等到变成有值再触发
);

onMounted(() => {
  
  
  if (Platform.client != 'h5') {
    jumpTopBottom.value = '80px'
  }
  // document.onscroll = function () {
  //   clearTimeout(timer);
  //   timer = setTimeout(isScrollEnd, 1000);
  //   showAnimation.value = false;
  //   scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //   if (scrollTop > 200) {
  //     jumpTop.value = true;
  //   } else {
  //     jumpTop.value = false;
  //   }
  // }
  checkAndRequestActiveAd();
})

onActivated(() =>{
  
  checkAndRequestActiveAd();
});

const checkAndRequestActiveAd = async () => {
  
  const now = Date.now();

  
  // —— 1. 节流：60s 内不重复请求 —— 
  const lastReq = Number(Storage.get(LAST_REQ_KEY) || '0');
  if (lastReq && now - lastReq < THROTTLE_MS) {
    return;
  }
  // 更新「上次请求时间」  
  Storage.set(LAST_REQ_KEY, String(now));

  // —— 2. 读取上次弹窗时间 —— 
  const lastPopup = Number(Storage.get(LAST_TIME_KEY) || "0");

  // —— 3. 发接口拿最新广告配置 —— 
  const res: any = await encryptionGetActiveAdInfo({ ad_type: 'home_popup' });
  if (res.code != 200 || !Array.isArray(res.data) || res.data.length == 0) {
    return;
  }

  // —— 4. 判断是否该弹 —— 
  const ad = res.data[0];
  const intervalMs = ad.pop_interval * 1000;   // pop_interval 单位 秒 → 毫秒
  if (!lastPopup || now - lastPopup >= intervalMs) {
    activeObj.value = ad;
    showActiveAlertView.value = true;
    // 更新「上次弹窗时间」
    Storage.set(LAST_TIME_KEY, String(now));
  }
};


//福利图标的透明度
// const showAnimation = ref(true)
onUnmounted(() => {

})

// let scrollTop = 0;
// let scrollEndTop = 0;
// let timer = null;

// const isScrollEnd = () => {
//   scrollEndTop = document.documentElement.scrollTop || document.body.scrollTop;
//   if (scrollTop === scrollEndTop) {
//     showAnimation.value = true
//   }
// }

const loadingsta = ref(false);
// const Swipers = ref(null);
const Populartodays = ref(null);

// const onRefresh = () => {
//   Swipers.value.getalldata();
//   Populartodays.value.getalldata();
// };

let Popul = ref(0);
let banner = ref(0);
let loading = ref(true);
const editConfirm = (data) => {
  if (data.value.title == "Populartoday") {
    Popul.value = 1;
  } else if (data.value.title == "Swiper") {
    banner.value = 1;
  }

  if (Popul.value == 1 && banner.value == 1) {
    // 两个组件的请求执行完成
    loadingsta.value = false;
    loading.value = false;
    Popul.value = 0;
    banner.value = 0;
  } else {
    setTimeout(() => {
      loadingsta.value = false;
      loading.value = false;
      Popul.value = 0;
      banner.value = 0;
    }, 3500);
  }
};

const tabscr = (data) => {
  // 更多点击
  emit("hometab", data);
};

const jumpTop = ref(false)
const jumpTopFn = () => {
  window.scroll({ top: 0, left: 0, behavior: "smooth" });
}
const th = process.env.VUE_APP_Language as string;

const screen = document.documentElement;
// const toActivity = () => {
//   nativeToNewWeb(router, '/activity?a=1');
//   window.$apiNet.statisticsPost({ action_id: 24 });
// }

// const toInvite = () => {
//   nativeToNewWeb(router, '/invitef?a=1');
//   window.$apiNet.statisticsPost({ action_id: 24 });
// }

const onKehuClick = () => {
  let chatkey = IMUtils.createChatKey(Platform.serverId);
  router.push(`/chat/?id=${chatkey}`);
}

const onActivityClick = (item) => {
  console.log(item);

  if (item.jump_type && item.jump_type != "") {
    
    if (item.jump_type == 1) {
      let { jump_url } = item;
      if (jump_url.startsWith("/")) {
        nativeToNewWeb(router, jump_url);
      } else {
        toLocationBrowser(jump_url);
      }

    } else if (item.jump_type == 2) {
      nativeToNewWeb(router, `/player?id=${item.jump_room_id}&&matchType=${item.platform_type}`)
    } else if (item.jump_type == 3) {
      nativeToNewWeb(router, `/player?id=${item.jump_room_id}&&matchType=${item.platform_type}`)
    } else if (item.jump_type == 5) {
      const id = parseInt(item.type_id);
      let chatkey;
      chatkey = IMUtils.createChatKey(id).toString();
      toMsgChat(router, id, chatkey);
    } else if (item.jump_type == 6) {
      nativeToNewWeb(router, `/invitef?a=b`)
      window.$apiNet.statisticsPost({ action_id: 24 });
    } else if (item.jump_type == 7) {
      nativeToNewWeb(router, '/activity?a=1');
      window.$apiNet.statisticsPost({ action_id: 24 });
    }
  }
  showActiveAlertView.value = false;
};

const closeActive = () => {
  showActiveAlertView.value = false;
}

const onSearch = ()=>{
  router.push('/search');
}

const logo = require(`@/assets/vi/logo_home.png`);


const __returned__ = { TopNav, ConfigpiniaStore, is_has_history, emit, downLogo, close_icon, kehu_icon, play_off_btn, showKehu, standalone, activeColor, activeFontColor, showDownApp, showActiveAlertView, activeCloseIcon, active_bg, activeObj, LAST_TIME_KEY, LAST_REQ_KEY, THROTTLE_MS, jumpTopBottom, showTodayMatch, props, homeCategoryType_vi, defaultActive, onNavTab, checkAndRequestActiveAd, loadingsta, Populartodays, Popul, banner, loading, editConfirm, tabscr, jumpTop, jumpTopFn, th, screen, onKehuClick, onActivityClick, closeActive, onSearch, logo, Swiper, Populartoday, toDownloadApp }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})